import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { useSelector } from "react-redux";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from '../../ToolTip/TooltipComp';
import { ReactComponent as StarIcon } from "../../../Icons/darkstar.svg";
export default function NameInfo({ data,tab}) {
  // console.log(data,'check check check')
  const searchState = useSelector((state) => state.search);
   const [isStapled, setIsStapled] = useState(false);
  const userState = useSelector((state) => state.user);
  const onCLickFavorite = () => {

  };
  const userProfile = () => {
    let img = "";
    img = searchState.usersProfilePicData.find(
      // (obj) => obj.uuid == data?.answers[0]?.expertImage?.uuid
      (obj) => obj.uuid == data?.answers[0]?.expertImage
    );
    // console.log('img',img)
    if (img !== undefined) {
      return `data:image/JPEG;base64,${img.img}`;
    }
  };

  // console.log("data.answers[0].expertImage.uuid",data.answers[0])
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "baseline",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
          {arr.map((item, index) => (
            <div className="mb-1">
              {" "}
              <AttachmentBox key={index} attachment={item} />
            </div>
          ))}
      </div>
    );
  };

//  console.log("attachments",data)
  return (
    <>
      <div style={infoContainer}>
        <div>
          {data.docType === "expertqa" && (
            <Avatar
              size={48}
              src={userProfile() || require("../../../Images/cliente.png")}
            ></Avatar>
          )}
          {data.docType !== "expertqa" && (
            <Avatar
              size={48}
              src={require("../../../Images/bot-icon.png")}
            ></Avatar>
          )}
        </div>
        <div style={dateInfoStyles}>
          {
            tab==2? <div>
            {data.docType === "expertqa" && (
              <div style={textStyles}>
                {data.answers[0].expert.firstName} {data.answers[0].expert.lastName}&nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data?.answers[0].expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )}
            {data.docType !== "expertqa" && (
              <div style={textStyles}>
                {data.docName === "" || data.docName === undefined
                  ? `${data?.postedUserFirstName}  ${data?.postedUserLastName}`
                  : data.docName}
              </div>
            )}
            <div style={dateStyles}>
              {data.answeredTimestamp < data.lastUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.lastUpdatedTimestamp
                  ? data.lastUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>: <div>
            {data.docType === "expertqa"&&data?.expert.firstName!==undefined&&data.expert.lastName!==undefined && (
              <div style={textStyles}>
                {data?.expert?.firstName} {data?.expert?.lastName}&nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data?.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )}
            {data.docType !== "expertqa" && (
              <div style={textStyles}>
                {data.docName === "" || data.docName === undefined
                  ? `${data.expert.firstName} ${data.expert.lastName}`
                  : data.docName}
              </div>
            )}
            <div style={dateStyles}>
              {data.answeredTimestamp < data.lastUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.lastUpdatedTimestamp
                  ? data.lastUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>
          }
         
          <div style={infoContainer}>
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    fontWeight: "500",
                  }}
                >
                  <ViewIcon />
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
                
              )}
                
            {data.docType === "expertqa" && data.internal && (
              <div style={{ marginRight: "6px" }}>
                <InternalIcon />
              </div>
            )}
            { tab!==2&& data.docType === "expertqa" &&
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{  }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
            
            { tab==2&& data.docType === "expertqa" &&
              data.answers[0].attachments  &&
              data.answers[0].attachments .length > 0 && (
                <div style={{  }}>
                  <Popover title={renderAttachemnt(data.answers[0].attachments )}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
            {/* data.answers[0].attachments */}
            
              {/* {!data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginLeft:'5px'}}></i></span></TooltipComp>
              </div>} */}

          </div>
        </div>
      </div>
    </>
  );
}
